module.exports = __webpack_public_path__ + "img/exam_ready_bg.44d0833f.png";